/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AttemptQuestionBody } from '../models';
// @ts-ignore
import type { BulkDeleteBodyConstrained } from '../models';
// @ts-ignore
import type { BulkDeleteMockTestResponse } from '../models';
// @ts-ignore
import type { CreateAdminMockTestBody } from '../models';
// @ts-ignore
import type { CreateJobApplicantMockTestBody } from '../models';
// @ts-ignore
import type { CreateMockTestBody } from '../models';
// @ts-ignore
import type { CreateMockTestRepsonse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GenerateSkillTestBody } from '../models';
// @ts-ignore
import type { GenerateSkillTestResponse } from '../models';
// @ts-ignore
import type { GetAllMocktestSkillsResponse } from '../models';
// @ts-ignore
import type { GetAllUserMockTestResponse } from '../models';
// @ts-ignore
import type { GetMockTestByIdResponse } from '../models';
// @ts-ignore
import type { GetMockTestPrerequisiteStatusResponse } from '../models';
// @ts-ignore
import type { MockTestAnalyticsResponse } from '../models';
// @ts-ignore
import type { MockTestUpdateResponse } from '../models';
// @ts-ignore
import type { MocktestAttemptQuestionResponse } from '../models';
// @ts-ignore
import type { OngoingStatisticsResponse } from '../models';
// @ts-ignore
import type { StartStatisticsRepsonse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UnansweredQuestionResponseSchemaSkillDict } from '../models';
// @ts-ignore
import type { UpdateMockTestBody } from '../models';
// @ts-ignore
import type { UserMocktestRewards } from '../models';
/**
 * MocktestApiApi - axios parameter creator
 */
export const MocktestApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} questionId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiAttemptQuestion: async (questionId: string, attemptQuestionBody: AttemptQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('mocktestApiAttemptQuestion', 'questionId', questionId)
            // verify required parameter 'attemptQuestionBody' is not null or undefined
            assertParamExists('mocktestApiAttemptQuestion', 'attemptQuestionBody', attemptQuestionBody)
            const localVarPath = `/mocktest/question/{question_id}/attempt`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiCloseExam: async (mocktestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mocktestId' is not null or undefined
            assertParamExists('mocktestApiCloseExam', 'mocktestId', mocktestId)
            const localVarPath = `/mocktest/{mocktest_id}/close`
                .replace('{mocktest_id}', encodeURIComponent(String(mocktestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {CreateMockTestBody} createMockTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiCreateJobMocktest: async (jobId: string, orgId: string, createMockTestBody: CreateMockTestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('mocktestApiCreateJobMocktest', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('mocktestApiCreateJobMocktest', 'orgId', orgId)
            // verify required parameter 'createMockTestBody' is not null or undefined
            assertParamExists('mocktestApiCreateJobMocktest', 'createMockTestBody', createMockTestBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/associate-skilltest`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMockTestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateMockTestBody} createMockTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiCreateMocktest: async (createMockTestBody: CreateMockTestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMockTestBody' is not null or undefined
            assertParamExists('mocktestApiCreateMocktest', 'createMockTestBody', createMockTestBody)
            const localVarPath = `/mocktest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMockTestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAdminMockTestBody} createAdminMockTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiCreateMocktestAdmin: async (createAdminMockTestBody: CreateAdminMockTestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAdminMockTestBody' is not null or undefined
            assertParamExists('mocktestApiCreateMocktestAdmin', 'createAdminMockTestBody', createAdminMockTestBody)
            const localVarPath = `/admin/mocktest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdminMockTestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateJobApplicantMockTestBody} createJobApplicantMockTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiCreateMocktestJobs: async (createJobApplicantMockTestBody: CreateJobApplicantMockTestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createJobApplicantMockTestBody' is not null or undefined
            assertParamExists('mocktestApiCreateMocktestJobs', 'createJobApplicantMockTestBody', createJobApplicantMockTestBody)
            const localVarPath = `/mocktest/job-applicant-mocktest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJobApplicantMockTestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiDeleteExam: async (mocktestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mocktestId' is not null or undefined
            assertParamExists('mocktestApiDeleteExam', 'mocktestId', mocktestId)
            const localVarPath = `/admin/mocktest/{mocktest_id}`
                .replace('{mocktest_id}', encodeURIComponent(String(mocktestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkDeleteBodyConstrained} bulkDeleteBodyConstrained 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiDeleteMocktestBulk: async (bulkDeleteBodyConstrained: BulkDeleteBodyConstrained, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDeleteBodyConstrained' is not null or undefined
            assertParamExists('mocktestApiDeleteMocktestBulk', 'bulkDeleteBodyConstrained', bulkDeleteBodyConstrained)
            const localVarPath = `/admin/mocktest/bulk_delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteBodyConstrained, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGenerateMocktestCertificate: async (mocktestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mocktestId' is not null or undefined
            assertParamExists('mocktestApiGenerateMocktestCertificate', 'mocktestId', mocktestId)
            const localVarPath = `/mocktest/{mocktest_id}/generate-certificate`
                .replace('{mocktest_id}', encodeURIComponent(String(mocktestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateSkillTestBody} generateSkillTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGenerateSkilltests: async (generateSkillTestBody: GenerateSkillTestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateSkillTestBody' is not null or undefined
            assertParamExists('mocktestApiGenerateSkilltests', 'generateSkillTestBody', generateSkillTestBody)
            const localVarPath = `/admin/mocktest/generate-skilltests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateSkillTestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetAdminMockExams: async (name?: string, pageNo?: number, pageSize?: number, skillIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/mocktest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [byUserSkills] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [skill] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetAllMocktestSkills: async (byUserSkills?: boolean, pageNo?: number, pageSize?: number, skill?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mocktest/skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (byUserSkills !== undefined) {
                localVarQueryParameter['by_user_skills'] = byUserSkills;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (skill !== undefined) {
                localVarQueryParameter['skill'] = skill;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetMocktestAnalytics: async (mocktestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mocktestId' is not null or undefined
            assertParamExists('mocktestApiGetMocktestAnalytics', 'mocktestId', mocktestId)
            const localVarPath = `/mocktest/{mocktest_id}/analytics`
                .replace('{mocktest_id}', encodeURIComponent(String(mocktestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetMocktestById: async (mocktestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mocktestId' is not null or undefined
            assertParamExists('mocktestApiGetMocktestById', 'mocktestId', mocktestId)
            const localVarPath = `/mocktest/{mocktest_id}`
                .replace('{mocktest_id}', encodeURIComponent(String(mocktestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetMocktestPrerequisiteStatus: async (mocktestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mocktestId' is not null or undefined
            assertParamExists('mocktestApiGetMocktestPrerequisiteStatus', 'mocktestId', mocktestId)
            const localVarPath = `/mocktest/{mocktest_id}/prerequisite-status`
                .replace('{mocktest_id}', encodeURIComponent(String(mocktestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetMocktestStartStatistics: async (mocktestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mocktestId' is not null or undefined
            assertParamExists('mocktestApiGetMocktestStartStatistics', 'mocktestId', mocktestId)
            const localVarPath = `/mocktest/{mocktest_id}/start-statistics`
                .replace('{mocktest_id}', encodeURIComponent(String(mocktestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetOngoingAnalytics: async (mocktestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mocktestId' is not null or undefined
            assertParamExists('mocktestApiGetOngoingAnalytics', 'mocktestId', mocktestId)
            const localVarPath = `/mocktest/{mocktest_id}/analytics/ongoing`
                .replace('{mocktest_id}', encodeURIComponent(String(mocktestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {string | null} [questionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetUnansweredQuestionByExam: async (mocktestId: string, questionId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mocktestId' is not null or undefined
            assertParamExists('mocktestApiGetUnansweredQuestionByExam', 'mocktestId', mocktestId)
            const localVarPath = `/mocktest/{mocktest_id}/unanswered`
                .replace('{mocktest_id}', encodeURIComponent(String(mocktestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (questionId !== undefined) {
                localVarQueryParameter['question_id'] = questionId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [byUserSkills] 
         * @param {number | null} [difficulty] 
         * @param {boolean} [isTemplate] 
         * @param {number | null} [maxDuration] 
         * @param {number | null} [maxQuestions] 
         * @param {number | null} [minDuration] 
         * @param {number | null} [minQuestions] 
         * @param {string} [name] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetUserDomainMockExams: async (byUserSkills?: boolean, difficulty?: number | null, isTemplate?: boolean, maxDuration?: number | null, maxQuestions?: number | null, minDuration?: number | null, minQuestions?: number | null, name?: string, pageNo?: number, pageSize?: number, skillIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mocktest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (byUserSkills !== undefined) {
                localVarQueryParameter['by_user_skills'] = byUserSkills;
            }

            if (difficulty !== undefined) {
                localVarQueryParameter['difficulty'] = difficulty;
            }

            if (isTemplate !== undefined) {
                localVarQueryParameter['is_template'] = isTemplate;
            }

            if (maxDuration !== undefined) {
                localVarQueryParameter['max_duration'] = maxDuration;
            }

            if (maxQuestions !== undefined) {
                localVarQueryParameter['max_questions'] = maxQuestions;
            }

            if (minDuration !== undefined) {
                localVarQueryParameter['min_duration'] = minDuration;
            }

            if (minQuestions !== undefined) {
                localVarQueryParameter['min_questions'] = minQuestions;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiStartExam: async (mocktestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mocktestId' is not null or undefined
            assertParamExists('mocktestApiStartExam', 'mocktestId', mocktestId)
            const localVarPath = `/mocktest/{mocktest_id}/start`
                .replace('{mocktest_id}', encodeURIComponent(String(mocktestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {UpdateMockTestBody} updateMockTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiUpdateMocktestDetail: async (mocktestId: string, updateMockTestBody: UpdateMockTestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mocktestId' is not null or undefined
            assertParamExists('mocktestApiUpdateMocktestDetail', 'mocktestId', mocktestId)
            // verify required parameter 'updateMockTestBody' is not null or undefined
            assertParamExists('mocktestApiUpdateMocktestDetail', 'updateMockTestBody', updateMockTestBody)
            const localVarPath = `/admin/mocktest/{mocktest_id}`
                .replace('{mocktest_id}', encodeURIComponent(String(mocktestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMockTestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MocktestApiApi - functional programming interface
 */
export const MocktestApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MocktestApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} questionId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiAttemptQuestion(questionId: string, attemptQuestionBody: AttemptQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MocktestAttemptQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiAttemptQuestion(questionId, attemptQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiAttemptQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiCloseExam(mocktestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiCloseExam(mocktestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiCloseExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {CreateMockTestBody} createMockTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiCreateJobMocktest(jobId: string, orgId: string, createMockTestBody: CreateMockTestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateMockTestRepsonse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiCreateJobMocktest(jobId, orgId, createMockTestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiCreateJobMocktest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateMockTestBody} createMockTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiCreateMocktest(createMockTestBody: CreateMockTestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateMockTestRepsonse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiCreateMocktest(createMockTestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiCreateMocktest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateAdminMockTestBody} createAdminMockTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiCreateMocktestAdmin(createAdminMockTestBody: CreateAdminMockTestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateMockTestRepsonse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiCreateMocktestAdmin(createAdminMockTestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiCreateMocktestAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateJobApplicantMockTestBody} createJobApplicantMockTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiCreateMocktestJobs(createJobApplicantMockTestBody: CreateJobApplicantMockTestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateMockTestRepsonse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiCreateMocktestJobs(createJobApplicantMockTestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiCreateMocktestJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiDeleteExam(mocktestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiDeleteExam(mocktestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiDeleteExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkDeleteBodyConstrained} bulkDeleteBodyConstrained 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiDeleteMocktestBulk(bulkDeleteBodyConstrained: BulkDeleteBodyConstrained, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDeleteMockTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiDeleteMocktestBulk(bulkDeleteBodyConstrained, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiDeleteMocktestBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiGenerateMocktestCertificate(mocktestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMocktestRewards>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiGenerateMocktestCertificate(mocktestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiGenerateMocktestCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateSkillTestBody} generateSkillTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiGenerateSkilltests(generateSkillTestBody: GenerateSkillTestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateSkillTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiGenerateSkilltests(generateSkillTestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiGenerateSkilltests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiGetAdminMockExams(name?: string, pageNo?: number, pageSize?: number, skillIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllUserMockTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiGetAdminMockExams(name, pageNo, pageSize, skillIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiGetAdminMockExams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [byUserSkills] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [skill] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiGetAllMocktestSkills(byUserSkills?: boolean, pageNo?: number, pageSize?: number, skill?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllMocktestSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiGetAllMocktestSkills(byUserSkills, pageNo, pageSize, skill, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiGetAllMocktestSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiGetMocktestAnalytics(mocktestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MockTestAnalyticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiGetMocktestAnalytics(mocktestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiGetMocktestAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiGetMocktestById(mocktestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMockTestByIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiGetMocktestById(mocktestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiGetMocktestById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiGetMocktestPrerequisiteStatus(mocktestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMockTestPrerequisiteStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiGetMocktestPrerequisiteStatus(mocktestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiGetMocktestPrerequisiteStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiGetMocktestStartStatistics(mocktestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartStatisticsRepsonse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiGetMocktestStartStatistics(mocktestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiGetMocktestStartStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiGetOngoingAnalytics(mocktestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OngoingStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiGetOngoingAnalytics(mocktestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiGetOngoingAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {string | null} [questionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiGetUnansweredQuestionByExam(mocktestId: string, questionId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnansweredQuestionResponseSchemaSkillDict>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiGetUnansweredQuestionByExam(mocktestId, questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiGetUnansweredQuestionByExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [byUserSkills] 
         * @param {number | null} [difficulty] 
         * @param {boolean} [isTemplate] 
         * @param {number | null} [maxDuration] 
         * @param {number | null} [maxQuestions] 
         * @param {number | null} [minDuration] 
         * @param {number | null} [minQuestions] 
         * @param {string} [name] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiGetUserDomainMockExams(byUserSkills?: boolean, difficulty?: number | null, isTemplate?: boolean, maxDuration?: number | null, maxQuestions?: number | null, minDuration?: number | null, minQuestions?: number | null, name?: string, pageNo?: number, pageSize?: number, skillIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllUserMockTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiGetUserDomainMockExams(byUserSkills, difficulty, isTemplate, maxDuration, maxQuestions, minDuration, minQuestions, name, pageNo, pageSize, skillIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiGetUserDomainMockExams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiStartExam(mocktestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateMockTestRepsonse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiStartExam(mocktestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiStartExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mocktestId 
         * @param {UpdateMockTestBody} updateMockTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mocktestApiUpdateMocktestDetail(mocktestId: string, updateMockTestBody: UpdateMockTestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MockTestUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mocktestApiUpdateMocktestDetail(mocktestId, updateMockTestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MocktestApiApi.mocktestApiUpdateMocktestDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MocktestApiApi - factory interface
 */
export const MocktestApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MocktestApiApiFp(configuration)
    return {
        /**
         * 
         * @param {MocktestApiApiMocktestApiAttemptQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiAttemptQuestion(requestParameters: MocktestApiApiMocktestApiAttemptQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<MocktestAttemptQuestionResponse> {
            return localVarFp.mocktestApiAttemptQuestion(requestParameters.questionId, requestParameters.attemptQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiCloseExamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiCloseExam(requestParameters: MocktestApiApiMocktestApiCloseExamRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.mocktestApiCloseExam(requestParameters.mocktestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiCreateJobMocktestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiCreateJobMocktest(requestParameters: MocktestApiApiMocktestApiCreateJobMocktestRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateMockTestRepsonse> {
            return localVarFp.mocktestApiCreateJobMocktest(requestParameters.jobId, requestParameters.orgId, requestParameters.createMockTestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiCreateMocktestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiCreateMocktest(requestParameters: MocktestApiApiMocktestApiCreateMocktestRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateMockTestRepsonse> {
            return localVarFp.mocktestApiCreateMocktest(requestParameters.createMockTestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiCreateMocktestAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiCreateMocktestAdmin(requestParameters: MocktestApiApiMocktestApiCreateMocktestAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateMockTestRepsonse> {
            return localVarFp.mocktestApiCreateMocktestAdmin(requestParameters.createAdminMockTestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiCreateMocktestJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiCreateMocktestJobs(requestParameters: MocktestApiApiMocktestApiCreateMocktestJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateMockTestRepsonse> {
            return localVarFp.mocktestApiCreateMocktestJobs(requestParameters.createJobApplicantMockTestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiDeleteExamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiDeleteExam(requestParameters: MocktestApiApiMocktestApiDeleteExamRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.mocktestApiDeleteExam(requestParameters.mocktestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiDeleteMocktestBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiDeleteMocktestBulk(requestParameters: MocktestApiApiMocktestApiDeleteMocktestBulkRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkDeleteMockTestResponse> {
            return localVarFp.mocktestApiDeleteMocktestBulk(requestParameters.bulkDeleteBodyConstrained, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiGenerateMocktestCertificateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGenerateMocktestCertificate(requestParameters: MocktestApiApiMocktestApiGenerateMocktestCertificateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserMocktestRewards> {
            return localVarFp.mocktestApiGenerateMocktestCertificate(requestParameters.mocktestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiGenerateSkilltestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGenerateSkilltests(requestParameters: MocktestApiApiMocktestApiGenerateSkilltestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateSkillTestResponse> {
            return localVarFp.mocktestApiGenerateSkilltests(requestParameters.generateSkillTestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiGetAdminMockExamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetAdminMockExams(requestParameters: MocktestApiApiMocktestApiGetAdminMockExamsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllUserMockTestResponse> {
            return localVarFp.mocktestApiGetAdminMockExams(requestParameters.name, requestParameters.pageNo, requestParameters.pageSize, requestParameters.skillIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiGetAllMocktestSkillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetAllMocktestSkills(requestParameters: MocktestApiApiMocktestApiGetAllMocktestSkillsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllMocktestSkillsResponse> {
            return localVarFp.mocktestApiGetAllMocktestSkills(requestParameters.byUserSkills, requestParameters.pageNo, requestParameters.pageSize, requestParameters.skill, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiGetMocktestAnalyticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetMocktestAnalytics(requestParameters: MocktestApiApiMocktestApiGetMocktestAnalyticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MockTestAnalyticsResponse> {
            return localVarFp.mocktestApiGetMocktestAnalytics(requestParameters.mocktestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiGetMocktestByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetMocktestById(requestParameters: MocktestApiApiMocktestApiGetMocktestByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMockTestByIdResponse> {
            return localVarFp.mocktestApiGetMocktestById(requestParameters.mocktestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiGetMocktestPrerequisiteStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetMocktestPrerequisiteStatus(requestParameters: MocktestApiApiMocktestApiGetMocktestPrerequisiteStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMockTestPrerequisiteStatusResponse> {
            return localVarFp.mocktestApiGetMocktestPrerequisiteStatus(requestParameters.mocktestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiGetMocktestStartStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetMocktestStartStatistics(requestParameters: MocktestApiApiMocktestApiGetMocktestStartStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartStatisticsRepsonse> {
            return localVarFp.mocktestApiGetMocktestStartStatistics(requestParameters.mocktestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiGetOngoingAnalyticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetOngoingAnalytics(requestParameters: MocktestApiApiMocktestApiGetOngoingAnalyticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OngoingStatisticsResponse> {
            return localVarFp.mocktestApiGetOngoingAnalytics(requestParameters.mocktestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiGetUnansweredQuestionByExamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetUnansweredQuestionByExam(requestParameters: MocktestApiApiMocktestApiGetUnansweredQuestionByExamRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnansweredQuestionResponseSchemaSkillDict> {
            return localVarFp.mocktestApiGetUnansweredQuestionByExam(requestParameters.mocktestId, requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiGetUserDomainMockExamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiGetUserDomainMockExams(requestParameters: MocktestApiApiMocktestApiGetUserDomainMockExamsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllUserMockTestResponse> {
            return localVarFp.mocktestApiGetUserDomainMockExams(requestParameters.byUserSkills, requestParameters.difficulty, requestParameters.isTemplate, requestParameters.maxDuration, requestParameters.maxQuestions, requestParameters.minDuration, requestParameters.minQuestions, requestParameters.name, requestParameters.pageNo, requestParameters.pageSize, requestParameters.skillIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiStartExamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiStartExam(requestParameters: MocktestApiApiMocktestApiStartExamRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateMockTestRepsonse> {
            return localVarFp.mocktestApiStartExam(requestParameters.mocktestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MocktestApiApiMocktestApiUpdateMocktestDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mocktestApiUpdateMocktestDetail(requestParameters: MocktestApiApiMocktestApiUpdateMocktestDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<MockTestUpdateResponse> {
            return localVarFp.mocktestApiUpdateMocktestDetail(requestParameters.mocktestId, requestParameters.updateMockTestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for mocktestApiAttemptQuestion operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiAttemptQuestionRequest {
    readonly questionId: string

    readonly attemptQuestionBody: AttemptQuestionBody
}

/**
 * Request parameters for mocktestApiCloseExam operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiCloseExamRequest {
    readonly mocktestId: string
}

/**
 * Request parameters for mocktestApiCreateJobMocktest operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiCreateJobMocktestRequest {
    readonly jobId: string

    readonly orgId: string

    readonly createMockTestBody: CreateMockTestBody
}

/**
 * Request parameters for mocktestApiCreateMocktest operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiCreateMocktestRequest {
    readonly createMockTestBody: CreateMockTestBody
}

/**
 * Request parameters for mocktestApiCreateMocktestAdmin operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiCreateMocktestAdminRequest {
    readonly createAdminMockTestBody: CreateAdminMockTestBody
}

/**
 * Request parameters for mocktestApiCreateMocktestJobs operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiCreateMocktestJobsRequest {
    readonly createJobApplicantMockTestBody: CreateJobApplicantMockTestBody
}

/**
 * Request parameters for mocktestApiDeleteExam operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiDeleteExamRequest {
    readonly mocktestId: string
}

/**
 * Request parameters for mocktestApiDeleteMocktestBulk operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiDeleteMocktestBulkRequest {
    readonly bulkDeleteBodyConstrained: BulkDeleteBodyConstrained
}

/**
 * Request parameters for mocktestApiGenerateMocktestCertificate operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiGenerateMocktestCertificateRequest {
    readonly mocktestId: string
}

/**
 * Request parameters for mocktestApiGenerateSkilltests operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiGenerateSkilltestsRequest {
    readonly generateSkillTestBody: GenerateSkillTestBody
}

/**
 * Request parameters for mocktestApiGetAdminMockExams operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiGetAdminMockExamsRequest {
    readonly name?: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly skillIds?: Array<string>
}

/**
 * Request parameters for mocktestApiGetAllMocktestSkills operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiGetAllMocktestSkillsRequest {
    readonly byUserSkills?: boolean

    readonly pageNo?: number

    readonly pageSize?: number

    readonly skill?: string | null
}

/**
 * Request parameters for mocktestApiGetMocktestAnalytics operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiGetMocktestAnalyticsRequest {
    readonly mocktestId: string
}

/**
 * Request parameters for mocktestApiGetMocktestById operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiGetMocktestByIdRequest {
    readonly mocktestId: string
}

/**
 * Request parameters for mocktestApiGetMocktestPrerequisiteStatus operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiGetMocktestPrerequisiteStatusRequest {
    readonly mocktestId: string
}

/**
 * Request parameters for mocktestApiGetMocktestStartStatistics operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiGetMocktestStartStatisticsRequest {
    readonly mocktestId: string
}

/**
 * Request parameters for mocktestApiGetOngoingAnalytics operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiGetOngoingAnalyticsRequest {
    readonly mocktestId: string
}

/**
 * Request parameters for mocktestApiGetUnansweredQuestionByExam operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiGetUnansweredQuestionByExamRequest {
    readonly mocktestId: string

    readonly questionId?: string | null
}

/**
 * Request parameters for mocktestApiGetUserDomainMockExams operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiGetUserDomainMockExamsRequest {
    readonly byUserSkills?: boolean

    readonly difficulty?: number | null

    readonly isTemplate?: boolean

    readonly maxDuration?: number | null

    readonly maxQuestions?: number | null

    readonly minDuration?: number | null

    readonly minQuestions?: number | null

    readonly name?: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly skillIds?: Array<string>
}

/**
 * Request parameters for mocktestApiStartExam operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiStartExamRequest {
    readonly mocktestId: string
}

/**
 * Request parameters for mocktestApiUpdateMocktestDetail operation in MocktestApiApi.
 */
export interface MocktestApiApiMocktestApiUpdateMocktestDetailRequest {
    readonly mocktestId: string

    readonly updateMockTestBody: UpdateMockTestBody
}

/**
 * MocktestApiApi - object-oriented interface
 */
export class MocktestApiApi extends BaseAPI {
    /**
     * 
     * @param {MocktestApiApiMocktestApiAttemptQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiAttemptQuestion(requestParameters: MocktestApiApiMocktestApiAttemptQuestionRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiAttemptQuestion(requestParameters.questionId, requestParameters.attemptQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiCloseExamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiCloseExam(requestParameters: MocktestApiApiMocktestApiCloseExamRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiCloseExam(requestParameters.mocktestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiCreateJobMocktestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiCreateJobMocktest(requestParameters: MocktestApiApiMocktestApiCreateJobMocktestRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiCreateJobMocktest(requestParameters.jobId, requestParameters.orgId, requestParameters.createMockTestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiCreateMocktestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiCreateMocktest(requestParameters: MocktestApiApiMocktestApiCreateMocktestRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiCreateMocktest(requestParameters.createMockTestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiCreateMocktestAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiCreateMocktestAdmin(requestParameters: MocktestApiApiMocktestApiCreateMocktestAdminRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiCreateMocktestAdmin(requestParameters.createAdminMockTestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiCreateMocktestJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiCreateMocktestJobs(requestParameters: MocktestApiApiMocktestApiCreateMocktestJobsRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiCreateMocktestJobs(requestParameters.createJobApplicantMockTestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiDeleteExamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiDeleteExam(requestParameters: MocktestApiApiMocktestApiDeleteExamRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiDeleteExam(requestParameters.mocktestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiDeleteMocktestBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiDeleteMocktestBulk(requestParameters: MocktestApiApiMocktestApiDeleteMocktestBulkRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiDeleteMocktestBulk(requestParameters.bulkDeleteBodyConstrained, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiGenerateMocktestCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiGenerateMocktestCertificate(requestParameters: MocktestApiApiMocktestApiGenerateMocktestCertificateRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiGenerateMocktestCertificate(requestParameters.mocktestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiGenerateSkilltestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiGenerateSkilltests(requestParameters: MocktestApiApiMocktestApiGenerateSkilltestsRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiGenerateSkilltests(requestParameters.generateSkillTestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiGetAdminMockExamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiGetAdminMockExams(requestParameters: MocktestApiApiMocktestApiGetAdminMockExamsRequest = {}, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiGetAdminMockExams(requestParameters.name, requestParameters.pageNo, requestParameters.pageSize, requestParameters.skillIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiGetAllMocktestSkillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiGetAllMocktestSkills(requestParameters: MocktestApiApiMocktestApiGetAllMocktestSkillsRequest = {}, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiGetAllMocktestSkills(requestParameters.byUserSkills, requestParameters.pageNo, requestParameters.pageSize, requestParameters.skill, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiGetMocktestAnalyticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiGetMocktestAnalytics(requestParameters: MocktestApiApiMocktestApiGetMocktestAnalyticsRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiGetMocktestAnalytics(requestParameters.mocktestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiGetMocktestByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiGetMocktestById(requestParameters: MocktestApiApiMocktestApiGetMocktestByIdRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiGetMocktestById(requestParameters.mocktestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiGetMocktestPrerequisiteStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiGetMocktestPrerequisiteStatus(requestParameters: MocktestApiApiMocktestApiGetMocktestPrerequisiteStatusRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiGetMocktestPrerequisiteStatus(requestParameters.mocktestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiGetMocktestStartStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiGetMocktestStartStatistics(requestParameters: MocktestApiApiMocktestApiGetMocktestStartStatisticsRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiGetMocktestStartStatistics(requestParameters.mocktestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiGetOngoingAnalyticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiGetOngoingAnalytics(requestParameters: MocktestApiApiMocktestApiGetOngoingAnalyticsRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiGetOngoingAnalytics(requestParameters.mocktestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiGetUnansweredQuestionByExamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiGetUnansweredQuestionByExam(requestParameters: MocktestApiApiMocktestApiGetUnansweredQuestionByExamRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiGetUnansweredQuestionByExam(requestParameters.mocktestId, requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiGetUserDomainMockExamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiGetUserDomainMockExams(requestParameters: MocktestApiApiMocktestApiGetUserDomainMockExamsRequest = {}, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiGetUserDomainMockExams(requestParameters.byUserSkills, requestParameters.difficulty, requestParameters.isTemplate, requestParameters.maxDuration, requestParameters.maxQuestions, requestParameters.minDuration, requestParameters.minQuestions, requestParameters.name, requestParameters.pageNo, requestParameters.pageSize, requestParameters.skillIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiStartExamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiStartExam(requestParameters: MocktestApiApiMocktestApiStartExamRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiStartExam(requestParameters.mocktestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MocktestApiApiMocktestApiUpdateMocktestDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mocktestApiUpdateMocktestDetail(requestParameters: MocktestApiApiMocktestApiUpdateMocktestDetailRequest, options?: RawAxiosRequestConfig) {
        return MocktestApiApiFp(this.configuration).mocktestApiUpdateMocktestDetail(requestParameters.mocktestId, requestParameters.updateMockTestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

